import {Typography} from '@mui/material';

import {WorkforceDashboardRoleCoverageHeatmapScoreCell} from './WorkforceDashboardRoleCoverageHeatmapScoreCell';
import {BasicTableCell, BasicTableRow} from '../../../../../components/BasicTable/BasicTableRow';
import type {WorkforceDashboardRoleCoverageRow} from '../../types/workforceDashboardTypes';

export interface WorkforceDashboardRoleCoverageHeatmapTableRow extends WorkforceDashboardRoleCoverageRow {
  id: string;
}

export type Props = WorkforceDashboardRoleCoverageHeatmapTableRow;

export const WorkforceDashboardRoleCoverageHeatmapRow = ({
  targetProfileTitle,
  profileCount,
  averageScores,
}: Props) => {
  return (
    <BasicTableRow rowVariant='flat'>
      <BasicTableCell sx={{fontWeight: 500, whiteSpace: 'nowrap'}}>{targetProfileTitle}</BasicTableCell>
      <BasicTableCell align='center'>
        <Typography variant='body2' sx={{color: 'text.secondary'}}>
          {profileCount}
        </Typography>
      </BasicTableCell>
      <BasicTableCell align='center'>
        <WorkforceDashboardRoleCoverageHeatmapScoreCell score={averageScores.coreCompetencies} />
      </BasicTableCell>
      <BasicTableCell align='center'>
        <WorkforceDashboardRoleCoverageHeatmapScoreCell score={averageScores.hardSkills} />
      </BasicTableCell>
      <BasicTableCell align='center'>
        <WorkforceDashboardRoleCoverageHeatmapScoreCell score={averageScores.softSkills} />
      </BasicTableCell>
      <BasicTableCell align='center'>
        <WorkforceDashboardRoleCoverageHeatmapScoreCell score={averageScores.responsibilities} />
      </BasicTableCell>
      <BasicTableCell align='center'>
        <WorkforceDashboardRoleCoverageHeatmapScoreCell score={averageScores.overall} />
      </BasicTableCell>
    </BasicTableRow>
  );
};
